import React from 'react';
import { Form, List } from 'antd';
import Button from 'app/components/Button';
import type { FormInstance } from 'rc-field-form';
import { PlusCircleOutlined } from '@ant-design/icons';
import { DefectItem } from './ListItem/DefectItem';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';

const DefectList = (props: { form: FormInstance<any>; [key: string]: any }) => {
  const { readonly } = props;
  const { configs: itemConfig } = props.config;
  React.useEffect(() => {
    const items = props.form.getFieldValue(props.name);
    if (!items || !items.length) {
      props.form.setFieldValue(props.name, [[...props.config.itemFields]]);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div>
      <DndProvider backend={HTML5Backend}>
        <Form.List name={props.name}>
          {(fields, operation) => {
            return (
              <List
                dataSource={fields}
                footer={
                  <Button
                    hidden={readonly}
                    icon={<PlusCircleOutlined />}
                    type="link"
                    onClick={() => {
                      operation.add(
                        [...props.config.itemFields],
                        fields.length
                      );
                    }}
                  >
                    Add Defect
                  </Button>
                }
                renderItem={(item, index) => {
                  const itemFields = props.form.getFieldValue([
                    ...props.name,
                    item.name
                  ]);
                  return (
                    <DefectItem
                      index={item.key}
                      onCopy={(fields) => {
                        operation.add([...fields]);
                      }}
                      onDelete={() => {
                        operation.remove(index);
                      }}
                      onMove={(from, to) => {
                        operation.move(from, to);
                      }}
                      // formInstance={props.form}
                      name={item.name}
                      // namePath={[...props.name]}
                      fields={itemFields}
                      config={itemConfig}
                      readonly={readonly}
                    ></DefectItem>
                  );
                }}
              ></List>
            );
          }}
        </Form.List>
      </DndProvider>
    </div>
  );
};

export default DefectList;
